import { stripeApi } from "../../api/stripeApi";

export const stripeApiMap = () => stripeApi;